import keyBy from 'lodash/keyBy';

import { blueprintVersions } from '../versions';

import type { Blueprint } from '../types';

const blueprintVersionMap = keyBy(blueprintVersions, 'version');

export type BlueprintVersion = keyof typeof blueprintVersionMap;

export function getBlueprintFromBlueprintVersion(
  blueprintVersion: BlueprintVersion
): Blueprint {
  return blueprintVersionMap[blueprintVersion];
}
